/**
 * @file: 商品 render 方法
 * @author: xiaolong.huang@dmall.com
 */

import { Watcher } from '../../observe/index';
import * as Toolkit from '../../toolkit/index';
import * as UIToolkit from '../../UIToolkit/index';
import * as CubeTree from '../../cubeTree/index';
import * as GoodsRenderCore from './renderCore/index';
import * as BafflePlateRenderCore from '../bafflePlate/renderCore/index';
import * as TextareaRenderCore from '../textarea/renderCore/index';

interface RenderErrorMsg {
    msg: string,
    code: number
}

export default function render(cube: CubeNode): void {
    // cube数据合法性校验
    let checkGoodsInfo: RenderErrorMsg = catchErrorMsg(cube);

    if (checkGoodsInfo.code !== 0) {
        return console.warn(checkGoodsInfo.msg);
    }

    // 隔板渲染
    if (CubeTree.isBafflePlate(cube.id)) {
        // 设置流动边框动画属性
        UIToolkit.setFlowBorderPropertiy(cube);

        new Watcher(() => {
            BafflePlateRenderCore.bafflePlate(cube);
        });
        return;
    }

    // 文本框渲染
    if (CubeTree.isTextarea(cube.id)) {
        // 设置流动边框动画属性
        UIToolkit.setFlowBorderPropertiy(cube);

        new Watcher(() => {
            TextareaRenderCore.textarea(cube);
        });
        return;
    }

    // 初始化cube jView的样式
    new Watcher(() => {
        GoodsRenderCore.initCubeDomStyle(cube);
    });

    // 渲染主商品
    new Watcher(() => {
        GoodsRenderCore.renderMainGoods(cube);
    });

    // 渲染x轴叠放商品
    new Watcher(() => {
        GoodsRenderCore.renderXLineGoodsFolded(cube);
    });

    // 渲染y轴叠放商品
    new Watcher(() => {
        GoodsRenderCore.renderYLineGoodsFolded(cube);
    });

    // 字母码渲染
    new Watcher(() => {
        GoodsRenderCore.renderSubGoods(cube);
    });

    // 挂钉渲染
    new Watcher(() => {
        GoodsRenderCore.renderNail(cube);
    });

    // 横杆挂钉标签渲染
    new Watcher(() => {
        GoodsRenderCore.renderBeamTag(cube);
    });

    // 主商品文字渲染
    new Watcher(() => {
        GoodsRenderCore.mainGoodsTxt(cube);
    });

    // 字码商品文字渲染
    new Watcher(() => {
        GoodsRenderCore.subGoodsTxt(cube);
    });

    // 渲染警告信息
    new Watcher(() => {
        UIToolkit.goodsWarning(cube);
    });

    // 商品渲染状态切换
    new Watcher(() => {
        GoodsRenderCore.statusSwitch(cube);
    });

    // 商品标签渲染
    new Watcher(() => {
        GoodsRenderCore.renderTag(cube);
    });

    // 商品不陈列标签渲染
    new Watcher(() => {
        GoodsRenderCore.renderDisplayTag(cube);
    });

    // 设置流动边框动画属性
    UIToolkit.setFlowBorderPropertiy(cube);
}

function catchErrorMsg(cube: CubeNode): RenderErrorMsg {
    let result: RenderErrorMsg = {
        code: 0,
        msg: 'success'
    };
    if (!UIToolkit.goodsIsValidate(cube.id)) {
        result.code = 1;
        result.msg = '商品渲染错误，暂无商品信息！！';
        return;
    }

    return result;
}
